import { render, staticRenderFns } from "./HeadItem.vue?vue&type=template&id=366351c8&"
import script from "./HeadItem.vue?vue&type=script&lang=js&"
export * from "./HeadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports